<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            type="year"
            default="today"
            label="기준년도"
            name="wasteYear"
            v-model="searchParam.wasteYear"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="월별 폐기물 발생량/생산량 목록"
      tableId="processManual"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'waste-report-manage',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'wasteYm',
            field: 'wasteYm',
            label: '기준월',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'wasteTransport',
            field: 'wasteTransport',
            type: 'cost',
            label: '폐기물 운반횟수',
            align: 'center',
            sortable: true,
          },
          {
            name: 'salesVolume',
            field: 'salesVolume',
            type: 'cost',
            label: '생산량(kg)',
            align: 'center',
            sortable: true,
          },
          {
            name: 'wasteUnit',
            field: 'wasteUnit',
            type: 'cost',
            label: '처리단가(원)',
            align: 'center',
            sortable: true,
          },
          {
            name: 'wasteCost',
            field: 'wasteCost',
            type: 'cost',
            label: '처리비용(원)',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        wasteYear: '',
        plantCd: null,
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '50%',
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.waste.volume.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./wasteVolumnDetail.vue"}`);
      this.popupOptions.title = '폐기물 발생량/판매량 상세';
      this.popupOptions.param = {
        envWasteVolumeId: result ? result.envWasteVolumeId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
